import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
const guarantees = ['Acceso inmediato', 'Para docentes de Hispanoamérica', 'Pago seguro'];
export function Hero() {
  return <header className="w-full bg-cream-100 px-6 pb-16 pt-12 sm:pt-16" data-id="element-67" data-mp="4m8lmajdinjv">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-68" data-mp="129h37ug97cgl">
        <span className="rounded-full bg-cream-200 px-5 py-2 text-xs font-semibold tracking-[0.22em] text-forest-700" data-id="element-69" data-mp="127eeddqu7pdg">
          KIT INSTRUMENTACIÓN INDUSTRIAL 2026
        </span>

        <h1 className="mt-8 font-display text-4xl font-bold leading-[1.05] text-forest-800 sm:text-6xl lg:text-7xl" data-id="element-70" data-mp="s9q8psrp0xgi">
          Del Sensor al Aula.
          <span className="mt-1 block text-ember-500" data-id="element-71" data-mp="3d1a99mbhsfec">Todo resuelto.</span>
        </h1>

        <img src={HERO_IMAGE} alt="Los 6 volúmenes del Kit Instrumentación Industrial 2026 junto a los 5 bonos, material imprimible y recursos digitales" className="mt-6 w-full max-w-2xl" data-id="element-72" data-mp="382fedm0930dv" />

        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-forest-700/75 sm:text-xl" data-id="element-73" data-mp="3o7vjnj38jlwr">
          Kit Instrumentación Industrial con 6 volúmenes técnicos, 5 bonos estratégicos e implementación
          docente 360°.
        </p>

        <ul className="mt-6 flex flex-col items-center gap-2 text-base text-forest-600 sm:flex-row sm:gap-7" data-id="element-74" data-mp="3e7uzjuxjl1ri">
          {guarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-75" data-mp="3599hs1zw9qrs">
              <CheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-76" data-mp="35audhuxy3fr8" />
              {item}
            </li>)}
        </ul>

        <CtaButton className="mt-9" source="hero" data-id="element-77" data-mp="2vi54d6pvadz2" />

        <div className="mt-6 flex flex-col items-center gap-3 text-sm text-forest-700/70 sm:flex-row sm:gap-5" data-id="element-78" data-mp="2vgu2jcfzfgal">
          <span className="flex items-center gap-2" data-id="element-79" data-mp="2lkqzm4db3dml">
            <span className="flex" aria-hidden="true" data-id="element-80" data-mp="2ljgzl9mw7vdb">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-81" data-mp="s2tb5evynxmk" />)}
            </span>
            4.9/5 — +150 docentes
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-82" data-mp="ibow6f6accrq" />
          <span className="flex items-center gap-2" data-id="element-83" data-mp="ddf44dfuxsac">
            <ShieldCheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-84" data-mp="deylk7d929dp" />
            Garantía 7 Días
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-85" data-mp="161t2iuauyqmf" />
          <span className="flex items-center gap-2" data-id="element-86" data-mp="15zztx9gopwbs">
            <CreditCardIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-87" data-mp="111omt6hrxzx9" />
            Tarjeta · Mercado Pago
          </span>
        </div>
      </div>
    </header>;
}